import React, { useEffect } from 'react';
import { Row, Col, Select, Tooltip } from 'antd';
import styled from 'styled-components';

import WorkOrderStore from 'stores/WorkOrderStore';

import { Container, StyledSelect } from './common';

import { tooltipText } from 'helpers/HelperFunctions';

const { Option } = Select;

function VMRSCompCode(props) {
  const {
    title,
    changeItemProperty,
    itemKey,
    vmrs_sys_code,
    vmrs_asm_code,
    vmrs_comp_code,
  } = props;

  const [compCodes, setCompCodes] = React.useState([]);
  const [filteredCodes, setFilteredCodes] = React.useState([]);

  useEffect(() => {
    async function fetchVMRSCompCodes() {
      if (!vmrs_sys_code || !vmrs_asm_code) return;

      const data = await WorkOrderStore.getVMRSCompCodes(
        vmrs_sys_code,
        vmrs_asm_code
      );
      setCompCodes(data);
      setFilteredCodes(data);
    }
    fetchVMRSCompCodes();
  }, [vmrs_sys_code, vmrs_asm_code]);

  const options = filteredCodes.map((item) => ({
    value: item.comp,
    label: (
      <span>
        {String(item.comp).padStart(3, '0')}{' '}
        <span className="certain-search-item-count">{item.description}</span>
      </span>
    ),
  }));

  const searchHandler = (value) => {
    const filtered = compCodes.filter((item) =>
      (
        String(item.comp).padStart(3, '0') +
        ' ' +
        item.description?.toLowerCase()
      ).includes(value.toLowerCase())
    );

    setFilteredCodes(filtered);
  };

  const handleChange = (value) => {
    const compCode = compCodes.find((d) => d.comp === value);
    const comp = String(compCode.comp).padStart(3, '0');
    const compDescription = compCode.description;

    changeItemProperty(itemKey, 'comp', String(value).padStart(3, '0'));

    changeItemProperty(itemKey, 'vmrs_comp_code_id', null);
    changeItemProperty(itemKey, 'vmrs_comp_code', comp);
    changeItemProperty(itemKey, 'vmrs_comp_text', compDescription);

    changeItemProperty(
      itemKey,
      'vmrs_full_code',
      `${vmrs_sys_code}-${vmrs_asm_code}-${comp}`
    );
    changeItemProperty(itemKey, 'vmrs_full_description', `${compDescription}`);
  };

  return (
    <Container id="container">
      <Row style={{ marginBottom: '5px' }}>
        <Col>{title}</Col>
      </Row>
      <Row>
        <Col span={24}>
          <Tooltip title={tooltipText(vmrs_comp_code)}>
            <StyledSelect
              showSearch
              onSearch={searchHandler}
              value={vmrs_comp_code == null ? '' : Number(vmrs_comp_code)}
              style={{ width: '100%' }}
              onChange={handleChange}
              filterOption={false}
              data-testid="vmrs-action-code-select"
              options={options}
            />
          </Tooltip>
        </Col>
      </Row>
    </Container>
  );
}

export default VMRSCompCode;
